import script from "./ErrorModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorModal.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorModal.vue?vue&type=style&index=0&id=001fdc36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-001fdc36"]])

export default __exports__